// components/trust/SkillBadgeList.jsx
import React from 'react';
import SkillBadge from './SkillBadge';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SkillBadgeList = ({ 
  skills, 
  maxDisplay = 3, 
  size = 'small', 
  showAddButton = false,
  onAddClick 
}) => {
  const navigate = useNavigate();
  
  const displaySkills = skills.slice(0, maxDisplay);
  const remainingCount = skills.length - maxDisplay;

  const handleAddClick = () => {
    if (onAddClick) {
      onAddClick();
    } else {
      navigate('/skills');
    }
  };

  return (
    <div className="flex flex-wrap gap-2 items-center">
      {displaySkills.map((skill, index) => (
        <SkillBadge 
          key={skill.id || index} 
          skill={skill} 
          size={size}
        />
      ))}
      
      {remainingCount > 0 && (
        <span className="text-sm text-gray-600">
          +{remainingCount} more
        </span>
      )}
      
      {showAddButton && (
        <button
          onClick={handleAddClick}
          className="inline-flex items-center px-3 py-1 text-sm border border-dashed border-gray-300 rounded-full text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-colors"
        >
          <Plus size={14} className="mr-1" />
          Add Skill
        </button>
      )}
    </div>
  );
};

export default SkillBadgeList;